import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';

export default {
  attributeName: 'appTransaction',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  editURL: routes.APP_PROVIDER_EDIT,
  emptyMessage: "There hasn't been a transaction yet.",
  fields: [
    {
      attributeName: 'ip',
      label: 'IP',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'IP address from the transaction was made',
      default: '',
      canEdit: false,
      width: '10rem',
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'130px'
    },
    {
      attributeName: 'country',
      label: 'Country',
      type: FormInputTypes.COUNTRY_FLAG,
      helpText: 'Country from the transaction was made',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'100px'
    },
    {
      attributeName: 'userValidationCode',
      label: 'Code Used',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Transaction code used',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      exactWidth:'150px'
    },
    {
      attributeName: 'appUserId',
      label: 'Device ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'ID of the device used',
    },
    {
      attributeName: 'platform',
      label: 'Platform',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'Platform of the device used',
      exactWidth:'100px'
    },
    {
      attributeName: 'appProviderId',
      label: 'Associated Provider',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'Virtual ticket provider.',
    },
    {
      attributeName: 'errorMessage',
      label: 'Error Message',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'Date when the transaction failed',
    },
    {
      attributeName: 'created_at',
      label: 'Failure Date',
      type: FormInputTypes.TIMESTAMP,
      canEdit: false,
      canCreate: false,
      default: '',
      canFilter: true,
      canOrder: true,
      helpText: 'ID of the device used',
    },
  ],
};
